// in src/posts.js
import React from 'react'
import {
  List,
  Datagrid,
  ChipField,
  DateField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  translate,
} from 'admin-on-rest'
import { Link } from 'react-router-dom'
import { StudentsCountField } from '../components/StudentsCountField'
import { dateParser } from '../helpers'

const CoursesCompletedList = props => (
  <List {...props} title="Istoric cursuri">
    <Datagrid key="id">
      <CourseTitle label="Denumire Curs" />
      <DateField label="Data curs" source="date" parse={dateParser} />
      <TextField label="Credite" source="credits" />
      <StudentsCountField label="Cursanti inscrisi" />
      <ReferenceManyField
        label="Lector"
        reference="instructors"
        target="courses"
        allowEmpty
      >
        <SingleFieldList>
          <ChipField source="displayName" />
        </SingleFieldList>
      </ReferenceManyField>
    </Datagrid>
  </List>
)

const CourseTitle = ({ record }) => (
  <Link to={`course/admin/${record.id}`}>{record.name}</Link>
)

export default translate(CoursesCompletedList)



// WEBPACK FOOTER //
// ./src/admin/AdminCoursesCompletedList.js